import { GameConstants } from "./GameConstants";
import { PreLoader } from "./states/Preloader";
import { SplashState } from "./states/splash-state/SplashState";
import { Boot } from "./states/Boot";
import { BoardState } from "./states/board-state/BoardState";

export class Game extends Phaser.Game {

    public static currentInstance: Game;

    constructor() {
        
        super(GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT, Phaser.AUTO, "content", null, true, true);

        Game.currentInstance = this;

        this.state.add("PreLoader", PreLoader, false); 
        this.state.add("SplashState", SplashState, false);
        this.state.add("BoardState", BoardState, false);
        this.state.add("Boot", Boot, true); 
    }
}
